import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { EditModule } from './edit/edit.module';
import { NgxsModule } from '@ngxs/store';
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
import { NgxsLoggerPluginModule } from '@ngxs/logger-plugin';
import { LayoutModule } from './layout/layout.module';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { DashboardModule } from './dashboard/dashboard.module';
import { ApiInterceptor } from './interceptors/api.interceptor';
import { ExploreModule } from './explore/explore.module';
import { BookmarksModule } from './bookmarks/bookmarks.module';
import { EngineModule } from './engine/engine.module';
import { StoryModule } from './story/story.module';
import { AuthModule } from './auth/auth.module';
import { OrganizationsModule } from './organizations/organizations.module';

import { ViewModule } from './view/view.module';

import { FontAwesomeConfigModule } from './font-awesome-config.module';
import { HistoryModule } from './history/history.module';
import { LocaleConfigModule } from './locale-config.module';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { environment } from 'src/environments/environment';

const providers = [
  { provide: HTTP_INTERCEPTORS, useClass: ApiInterceptor, multi: true }
];

@NgModule({
  declarations: [
    AppComponent,
    NotFoundComponent
  ],

  imports: [
    // This has to be at the top due to a bug in NgxsOnInit (https://github.com/ngxs/store/issues/539)
    NgxsModule.forRoot(),
    // NgxsReduxDevtoolsPluginModule.forRoot({
    //   disabled: environment.production
    // }),
    // NgxsLoggerPluginModule.forRoot({
    //   disabled: environment.production
    // }),

    // Icons
    FontAwesomeConfigModule,

    // Locales
    LocaleConfigModule.forRoot(),

    // NoopAnimationsModule, // Disable animations for faster UI
    BrowserAnimationsModule,
    BrowserModule,
    HttpClientModule,

    // App dependencies
    EngineModule,

    // Child features
    AuthModule,
    BookmarksModule,
    DashboardModule,
    EditModule,
    ExploreModule,
    HistoryModule,
    LayoutModule,
    OrganizationsModule,
    StoryModule,
    ViewModule,

    // App routing
    AppRoutingModule
  ],
  providers: providers,
  bootstrap: [AppComponent]
})
export class AppModule { }
